import { render } from "./localization-form.vue?vue&type=template&id=10cf2757"
import script from "./localization-form.vue?vue&type=script&lang=js"
export * from "./localization-form.vue?vue&type=script&lang=js"

import "./localization-form.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__